export const blockIconsAudioandvideoVolumeOff = (
	<span className='material-symbols-outlined'>volume_off</span>
);
